"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactPdf = require("react-pdf");
var _StudioLogger = require("@studio/logger/StudioLogger");
var logger = new _StudioLogger.StudioLogger('pdf-page');
var StudioPDFPage = function StudioPDFPage(props) {
  var onError = function onError(error) {
    console.error(error);
    logger.error('Unable to render page', error);
  };
  return /*#__PURE__*/_react["default"].createElement(_reactPdf.Page, (0, _extends2["default"])({}, props, {
    onGetAnnotationsError: onError,
    onGetStructTreeError: onError,
    onGetTextError: onError,
    onLoadError: onError,
    loading: '',
    onRenderAnnotationLayerError: onError,
    onRenderError: onError,
    onRenderTextLayerError: onError,
    renderAnnotationLayer: false,
    renderTextLayer: false
  }));
};
var _default = exports["default"] = StudioPDFPage;